import { render, staticRenderFns } from "./client-type.input.vue?vue&type=template&id=c3c0232c&"
import script from "./client-type.input.vue?vue&type=script&lang=ts&"
export * from "./client-type.input.vue?vue&type=script&lang=ts&"
import style0 from "./client-type.input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports